export default "__VITE_ASSET__70ba52a6__"